import { requestHacoCms } from 'apis/base'
import awsconfig from '../aws-exports'
import { CategoryFaqs, Faqs } from './response_types'

export const getCategoryFaqs = () => {
  let path = '/faq_categories'
  if (awsconfig.ENV_NAME !== 'production') {
    path = '/faq_categories_staging'
  }
  return requestHacoCms<CategoryFaqs>('get', path, { s: 'order' })
}

export const getFaqs = (params: Object) => {
  let path = '/faq'
  if (awsconfig.ENV_NAME !== 'production') {
    path = '/faq_staging'
  }
  return requestHacoCms<Faqs>('get', path, params)
}
